'use client';

import React, { createContext, useContext, useState, useCallback, ReactNode } from 'react';

interface ActiveProjectInfo {
  id: string;
  title: string;
}

interface ActiveProjectContextType {
  activeProject: ActiveProjectInfo | null;
  setActiveProject: (project: ActiveProjectInfo | null) => void;
}

const ActiveProjectContext = createContext<ActiveProjectContextType | undefined>(undefined);

interface ActiveProjectProviderProps {
  children: ReactNode;
}

export function ActiveProjectProvider({ children }: ActiveProjectProviderProps) {
  const [activeProject, setActiveProjectState] = useState<ActiveProjectInfo | null>(null);

  const setActiveProject = useCallback((project: ActiveProjectInfo | null) => {
    setActiveProjectState(project);
  }, []);

  return (
    <ActiveProjectContext.Provider value={{ activeProject, setActiveProject }}>
      {children}
    </ActiveProjectContext.Provider>
  );
}

export function useActiveProject(): ActiveProjectContextType {
  const context = useContext(ActiveProjectContext);

  if (context === undefined) {
    throw new Error('useActiveProject must be used within an ActiveProjectProvider');
  }

  return context;
}
